// src/Header.jsx
import { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaUser,
  FaShoppingCart,
  FaHome,         // Inicio
  FaList,         // Planes
  FaBriefcase,    // Empleo
  FaHandsHelping, // Asesoría
  FaBook,         // Educación
  FaGlobeAmericas,// Migración
  FaLightbulb     // Emprendimiento
} from "react-icons/fa";

import { AuthContext } from "../context/AuthContext";
import logo from "../assets/images/working-unidos-logo.png";
import "./Header.css";

const Header = () => {
  const [showStickyMenu, setShowStickyMenu] = useState(false);
  const { user, updateUser } = useContext(AuthContext);
  const navigate = useNavigate();

  // Mostrar el sticky header al hacer scroll > 300px
  useEffect(() => {
    const handleScroll = () => {
      setShowStickyMenu(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    updateUser(null);
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    navigate("/");
  };

  const isLoggedIn = !!user;
  const floatingLabel = isLoggedIn
    ? `Hola, ${user?.nombre || user?.username}`
    : "Inicia Sesión/Regístrate";
  // Siempre usar la ruta unificada para Mi Cuenta
  const floatingLink = isLoggedIn ? "/mi-cuenta" : "/choice";

  return (
    <>
      {/* Normal Header */}
      <header className="main-header">
        <div className="header-top">
          <div className="header-container">
            {/* Logo */}
            <div className="left-section">
              <Link to="/" className="logo-link">
                <img src={logo} alt="Working Unidos Logo" className="logo" />
              </Link>
            </div>

            {/* Sesión y carrito */}
            <div className="right-section">
              {user ? (
                <div className="user-session">
                  <button className="user-button" type="button">
                    <FaUser style={{ marginRight: "5px" }} />
                    Hola, {user.nombre || user.username}
                  </button>
                  <div className="session-dropdown">
                    <Link to="/mi-cuenta" className="session-link">
                      Mi Cuenta
                    </Link>
                    <button className="session-link" onClick={handleLogout}>
                      Cerrar Sesión
                    </button>
                  </div>
                </div>
              ) : (
                <Link to="/choice">
                  <button className="inicia-sesion-btn">
                    Inicia Sesión/Regístrate
                  </button>
                </Link>
              )}
              <Link to="/cart" className="cart-btn hide-on-mobile">
                <FaShoppingCart style={{ fontSize: "1.5rem" }} />
              </Link>
            </div>
          </div>
        </div>

        {/* Menú de íconos */}
        <nav className="icon-menu">
          <Link to="/" className="icon-menu-item hide-on-tablet">
            <FaHome />
            <span>Inicio</span>
          </Link>
          <Link to="/planes" className="icon-menu-item hide-on-tablet">
            <FaList />
            <span>Planes</span>
          </Link>
          <Link to="/empleos" className="icon-menu-item">
            <FaBriefcase />
            <span>Empleo</span>
          </Link>
          <Link to="/asesoria" className="icon-menu-item">
            <FaHandsHelping />
            <span>Asesoría</span>
          </Link>
          <Link to="/educate" className="icon-menu-item">
            <FaBook />
            <span>Educación</span>
          </Link>
          <Link to="/migration" className="icon-menu-item">
            <FaGlobeAmericas />
            <span>Migración</span>
          </Link>
          <Link to="/emprendimiento" className="icon-menu-item">
            <FaLightbulb />
            <span>Emprendimiento</span>
          </Link>
        </nav>
      </header>

      {/* Sticky Header */}
      {showStickyMenu && (
        <header className="sticky-header">
          <div className="sticky-container">
            <div className="sticky-left hide-sticky-mobile">
              <Link to="/" className="logo-link">
                <img src={logo} alt="Working Unidos Logo" className="logo" />
              </Link>
            </div>

            <nav className="sticky-icon-menu">
              <Link to="/" className="icon-menu-item hide-on-tablet">
                <FaHome />
                <span>Inicio</span>
              </Link>
              <Link to="/planes" className="icon-menu-item hide-on-tablet">
                <FaList />
                <span>Planes</span>
              </Link>
              <Link to="/empleos" className="icon-menu-item">
                <FaBriefcase />
                <span>Empleo</span>
              </Link>
              <Link to="/asesoria" className="icon-menu-item">
                <FaHandsHelping />
                <span>Asesoría</span>
              </Link>
              <Link to="/educate" className="icon-menu-item">
                <FaBook />
                <span>Educación</span>
              </Link>
              <Link to="/migration" className="icon-menu-item">
                <FaGlobeAmericas />
                <span>Migración</span>
              </Link>
              <Link to="/emprendimiento" className="icon-menu-item">
                <FaLightbulb />
                <span>Emprendimiento</span>
              </Link>
            </nav>

            <div className="sticky-right hide-sticky-mobile">
              {user ? (
                <div className="user-session">
                  <button className="user-button" type="button">
                    <FaUser style={{ marginRight: "5px" }} />
                    Hola, {user.nombre || user.username}
                  </button>
                  <div className="session-dropdown">
                    <Link to="/mi-cuenta" className="session-link">
                      Mi Cuenta
                    </Link>
                    <button className="session-link" onClick={handleLogout}>
                      Cerrar Sesión
                    </button>
                  </div>
                </div>
              ) : (
                <Link to="/choice">
                  <button className="inicia-sesion-btn">
                    Inicia Sesión/Regístrate
                  </button>
                </Link>
              )}
              <Link to="/cart" className="cart-btn hide-on-mobile">
                <FaShoppingCart style={{ fontSize: "1.5rem" }} />
              </Link>
            </div>
          </div>
        </header>
      )}

      {/* Floating button for small screens */}
      {showStickyMenu && (
        <Link to={floatingLink} className="floating-login-btn">
          {floatingLabel}
        </Link>
      )}
    </>
  );
};

export default Header;